import { render } from "./Medical.vue?vue&type=template&id=10284410"
import script from "./Medical.vue?vue&type=script&lang=js"
export * from "./Medical.vue?vue&type=script&lang=js"

import exportComponent from "/home/benjamin/projects/web-case/maxstock-firebase/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__